
import DeviceListRow from '@/components/devices/DeviceListRow.vue';
import { State, Mutation } from 'vuex-class';
import { DeviceInfo } from '@/types/device-info';
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { mutations } from '@/store/types';
import { SetDeviceMutationType } from '@/types/store/mutations';

@Component({
    components: {
        DeviceListRow,
    },
})
export default class AirboltsList extends Vue {
    protected itemsPerPage = 6;
    protected page = 1;

    @State('devices')
    devices!: DeviceInfo[];

    @State('device')
    current!: DeviceInfo;

    @Mutation(mutations.SET_CURRENT_DEVICE)
    setCurrentDevice!: SetDeviceMutationType;

    @State('selectedDeviceType')
    selectedDeviceType!: string;

    @State('searchName')
    searchName!: boolean;

    handleDeviceClick(device: DeviceInfo) {
        if (device._id != this.current._id) {
            const redirectURL = this.$route;
            if (redirectURL?.name === 'group-device') {
                this.setCurrentDevice({ device });
            } else {
                this.$router.push({ name: 'device-overview', params: { deviceUUID: device.deviceUUID as string } });
            }
        }
    }

    get numberOfPages() {
        return Math.ceil(this.devices.length / this.itemsPerPage);
    }
    nextPage() {
        if (this.page + 1 <= this.numberOfPages) this.page += 1;
    }
    formerPage() {
        if (this.page - 1 >= 1) this.page -= 1;
    }
    @Watch('selectedDeviceType')
    protected selectedDeviceTypeChanged() {
        this.page = 1;
    }
    @Watch('searchName')
    protected searchNameChanged() {
        this.page = 1;
    }
}
